import React from 'react'
import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Footer } from './Footer'
import { ErrorBoundary } from '../ui/ErrorBoundary'

export const Layout: React.FC = () => {
  return (
    <>
      <style>{`
        .layout-main {
          flex: 1;
          width: 100%;
          max-width: 1100px;
          margin: 0 auto;
          padding: 24px 16px 48px;
        }
      `}</style>
      <Header />
      <main className="layout-main">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
      <Footer />
    </>
  )
}
